import { getAreas } from '../services/areas-service';
import { getProcesses } from '../services/processes-service';
import { getSystems } from '../services/systems-service';
import { getAssets } from '../services/assets-service';

export const typeLabels = {
  areas: "Áreas de Negócios",
  processes: "Processos",
  systems: "Sistemas",
  assets: "Ativos",
  companies: "Empresa"
};

export const maturityLevels = {
  notPerformed: "Nível 0",
  performedInformally: "Nível 1",
  plannedTracked: "Nível 2",
  wellDefined: "Nível 3",
  quantitativelyControlled: "Nível 4",
  continuouslyImproving: "Nível 5"
};

export const statusControl = {
  noEntities: {
    label: "Não Vinculado",
    color: "#9E9E9E",
    description: "O controle não está vinculado a nenhuma entidade específica."
  },
  noResponse: {
    label: "Sem Resposta",
    color: "#757575",
    description: "O controle ainda não foi avaliado e nenhuma resposta foi fornecida."
  },
  deficient: {
    label: "Deficiente",
    color: "#D32F2F",
    description: "O controle não está implementado ou está parcialmente implementado."
  },
  implemented: {
    label: "Implementado",
    color: "#FF9800",
    description: "O controle está implementado, mas ainda não foi testado ou verificado."
  },
  readyForReview: {
    label: "Pronto para Revisão",
    color: "#FFC107",
    description: "Evidências foram coletadas e o controle está pronto para revisão por um avaliador."
  },
  monitored: {
    label: "Monitorado",
    color: "#4CAF50",
    description: "O controle foi avaliado e está em um estado de monitoramento contínuo."
  },
  notApplicable: {
    label: "Não Aplicável",
    color: "#72ba76",
    description: "O controle não se aplica a este contexto ou ambiente."
  }
};
export const options = [
  { label: "Empresa", value: "companies" },
  { label: "Áreas de negócio", value: "areas", fetchFunction: getAreas },
  { label: "Processos", value: "processes", fetchFunction: getProcesses },
  { label: "Sistemas", value: "systems", fetchFunction: getSystems },
  { label: "Ativos", value: "assets", fetchFunction: getAssets },
];

export const getSolutionKey = (size) => {
  if (size >= 1 && size <= 9) return "solutionsMicroSmall";
  if (size >= 10 && size <= 49) return "solutionsSmall";
  if (size >= 50 && size <= 249) return "solutionsMedium";
  if (size >= 250 && size <= 999) return "solutionsLarge";
  if (size >= 1000) return "solutionsEnterprise";
  return null;
};

export const getBreadcrumbBase = (pathname) => {
  const normalizedPath = pathname.toLowerCase().replace(/\/+$/, '');

  if (normalizedPath.includes('/gap-analysis')) return 'Assessment / Gap Analysis';
  if (normalizedPath.includes('/reports/compliance-program')) return 'Relatórios / Programa de Privacidade e Proteção de Dados';
  if (normalizedPath.includes('/compliance-program/') && normalizedPath.includes('/vincular')) return 'Gerenciar';
  if (normalizedPath.includes('/compliance-program')) return 'Gerenciar / Programa de Privacidade e Proteção de Dados';

  return 'Home';
};
